import {OrchestrateService} from '@digital-advice/ms-orchestrate-sdk';
import {apiKey, getLogger, interceptors, resolveEndpointForServiceToken, sourceInfo} from '@advisor/services/sdk';

export default class OrchestrateServices {
  static async sdkService(
    // eslint-disable-next-line unicorn/no-object-as-default-parameter
    options = {
      hasServiceTokenEndpoint: false,
    }
  ) {
    const service = await new OrchestrateService({
      logger: getLogger(),
      apiKey,
      endpoint: resolveEndpointForServiceToken(options.hasServiceTokenEndpoint),
      interceptors,
      sourceInfo,
    });

    return service;
  }

  /**
   * Gateway endpoint: sendEmailToClient
   * @param {requestId, clUserId, riaUserId, templateName, overWriteFields}
   */
  static async sendEmailToClient(options) {
    const sdkService = await this.sdkService();

    return sdkService.sendEmailToClient(options);
  }

  static async confirmEmail(payload) {
    const serviceOptions = {
      hasServiceTokenEndpoint: true,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.riaUserIdentityVerification(payload);
  }

  static async verifyEmail(payload) {
    const serviceOptions = {
      hasServiceTokenEndpoint: true,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.updateEmailWithWorkflows(payload);
  }

  static async emailChangeVerification(payload) {
    const serviceOptions = {
      hasServiceTokenEndpoint: true,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.updateEmailWithWorkflows(payload);
  }

  static async createOAthUser(payload) {
    const serviceOptions = {
      hasServiceTokenEndpoint: true,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.postRiaUserWorkflows(payload);
  }

  static async riaUserAuthentication(payload) {
    const serviceOptions = {
      hasServiceTokenEndpoint: true,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.postRiaUserWorkflows(payload);
  }

  /**
   * Gateway endpoint: postClUsersWorkflows
   * @payload {Object} {workflows[], oAuth2UserInfo?, verifyUserRequest?, clUser?, thirdPartyUserInfo?, emailVerificationInfo?, cdoParameter?}
   */
  static async sendClientRegistrationMail(payload) {
    const serviceOptions = {
      hasServiceTokenEndpoint: false,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.postClUsersWorkflows(payload);
  }

  /**
   * Updates account notifications.
   * @async
   * @param options - A {@link PostAccountOpeningOptions} object.
   * @return A promise of a {@link AccountOpeningResponse} object.
   *
   */
  static async postExistingClientAccountOpeningEmail(options) {
    const serviceOptions = {
      hasServiceTokenEndpoint: false,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.postExistingClientAccountOpeningEmail(options);
  }

  /**
   * Saves PFG_Wrapper.
   * @async
   * @param options - A {@link GetPfgWrapperOptions} object.
   *
   */
  static async postPfgWrapper(options) {
    const serviceOptions = {
      hasServiceTokenEndpoint: false,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.postPfgWrapper(options);
  }

  /**
   * Save new client and account informationr.
   * @async
   * @param options - A {@link SaveNewClientOptions} object.
   *
   */
  static async saveNewClient(options) {
    const serviceOptions = {
      hasServiceTokenEndpoint: false,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.saveNewClient(options);
  }

  /**
   * Supervision Account Opening Request Approve.
   * @async
   * @param options - A {@link PostSubmitAccountOptions} object.
   *
   */
  static async submitAccountRequest(options) {
    const serviceOptions = {
      hasServiceTokenEndpoint: false,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.submitAccountOpening(options);
  }

  /**
   * Preview Account Info review PDF.
   * @async
   * @param options - A {@link GetAccountInfoReviewPdfOptions} object.
   *
   */
  static async getAccountReviewPdf(options) {
    const serviceOptions = {
      hasServiceTokenEndpoint: false,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.getAccountReviewPdf(options);
  }
}
